<template>
  <restore-widget
    :title="$t('title')"
    :headers="headers"
    :items="items"
    :restore="doRestore"
    :delete="doDelete"
    :dismiss="dismiss"
    :data-loading="loading"
    item-key="boardRef"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE } from '../store'
import { RestoreWidget } from '../../components'

export default {
  name: 'EntityRestoreWidget',
  components: { RestoreWidget },
  props: {
    orgRef: String,
    boardRef: { type: String, required: true },
    dismiss: { type: Function, required: true }
  },
  data: () => ({ loading: true }),
  computed: {
    ...mapState(BOARD_NAMESPACE, ['entityType', 'columns']),
    ...mapState(NAMESPACE, ['archivedItems']),
    items() {
      return this.archivedItems.map((item) => {
        let stateObj = this.columns.find((state) => item.state === state.name)
        return { ...item, stateObj, id: item.entity.id }
      })
    },
    headers() {
      return [
        {
          text: this.$t('displayName'),
          value: 'entity.display',
          align: 'left'
        },
        {
          text: this.$t('state'),
          value: 'stateObj.display',
          align: 'left'
        }
      ]
    }
  },
  methods: {
    ...mapActions(NAMESPACE, [
      'listBoardItems',
      'listArchivedEntities',
      'clearArchivedEntities',
      'restoreEntities',
      'deleteEntities'
    ]),
    doRestore(selected) {
      let paths = selected.map((item) => item.entity.uris.self)
      return this.restoreEntities(paths).then(() => {
        return this.listBoardItems({ boardRef: this.boardRef })
      })
    },
    doDelete(selected) {
      let paths = selected.map((item) => item.entity.uris.self)
      return this.deleteEntities(paths).then(() => {
        return this.listBoardItems({ boardRef: this.boardRef })
      })
    }
  },
  mounted() {
    this.listArchivedEntities({ id: this.boardRef })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  },
  destroyed() {
    this.clearArchivedEntities()
  }
}
</script>

<i18n>
{
  "en": {
    "displayName": "@:labels.displayName",
    "state": "@:labels.state",
    "title": "Archived Entities"
  },
  "fr": {
    "displayName": "@:labels.displayName",
    "state": "@:labels.state",
    "title": "Entités archivées"
  }
}
</i18n>
